import {requirePermission} from '@/modules/auth/permissions'
// oxlint-disable no-non-null-assertion
import {useGetInfiniteSections} from '@/modules/sections/api'
import {SectionsTable} from '@/modules/sections/components'
import {SectionsFilters} from '@/modules/sections/components/sections-filters'
import {SectionsSearchSchema} from '@/modules/sections/schemas'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {HStack} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'
import {LuPlus} from 'react-icons/lu'
import {ResourcesIndexPageTable} from '@/shared/components/ui/resources-index-page-table'
import {type OnChangeFn, type SortingState} from '@tanstack/react-table'

const LIMIT = 50

export const Route = createFileRoute('/configuration/sections/')({
  beforeLoad: requirePermission('organisation.manage'),
  component: SectionsPage,
  validateSearch: SectionsSearchSchema,
})

function SectionsPage() {
  const {t} = useTranslate('common')
  const navigate = Route.useNavigate()
  const search = Route.useSearch()
  const [sort] = search.sort

  const infiniteSections = useGetInfiniteSections({
    limit: LIMIT,
    sort: {
      dir: sort?.desc ? 'desc' : 'asc',
      field: sort?.id || 'createdAt',
    },
    filters: {
      name: search.filters?.search,
      status: [],
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infiniteSections

  const onSortingChange = useCallback<OnChangeFn<SortingState>>(
    updaterOrValue => {
      const newValue = typeof updaterOrValue === 'function' ? updaterOrValue(search.sort) : updaterOrValue
      navigate({to: '.', search: prev => ({...prev, sort: newValue})})
    },
    [navigate, search.sort]
  )

  return (
    <>
      <HStack justifyContent="space-between" width="100%">
        <LinkButton to="/configuration/sections/new" marginY="1rem" colorPalette="cyan" size="sm">
          <LuPlus />
          {t('add_new')}
        </LinkButton>

        <SectionsFilters />
      </HStack>
      <ResourcesIndexPageTable>
        <SectionsTable
          virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
          table={{onSortingChange, state: {sorting: search.sort}}}
        />
      </ResourcesIndexPageTable>
    </>
  )
}
